import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSpaceSharedSvg } from "./IconSpaceSharedSvg.mjs";
const IconSpaceShared = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSpaceSharedSvg, ...iconProps });
};
export {
  IconSpaceShared
};
